import ButtonTertiary from './ButtonTertiary'
export default ButtonTertiary
